const { REACT_APP_IDENTIFIER_CONTRATANTE } = process.env;

export const getApplication = () => {
    const application = {
        id: 1,
        key: '@movcad',
        name: REACT_APP_IDENTIFIER_CONTRATANTE,
        port: '4000',
        ports: ['4000'],
    };

    return application;
};
